import React, {useEffect, useState} from 'react';
// import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import Header from "../Header/Header";
import {useAuth} from "../../context/AuthContext";
import {HOST} from "../../utils/vars";
import './RentalList.css'
import Loading from "../Loading/Loading";
import DialogModal from "../DialogModal/DialogModal";
import RentalListByDay from "./RentalListByDay";
import {IBilitestRental, IProductsInRental, IRental, ProductQuantity, ProductUserMatrixProps} from "./RentalInterfaces";
import ProductUserMatrix from "./ProductUserMatrix";

// export interface IRental {
//   id: number;
//   name: string;
//   prod_id: number;
//   product_id: number;
//   start_date: string;
//   end_date?: string;
//   status: string;
//   comment: string;
// }

interface DialogData {
  type: 'error' | 'confirm';
  title: string;
  message: string;
  id?: number | string;
}


// const statusClassMap: Record<string, string> = {
//   'создан': 'created',
//   'аренда': 'active',
//   'обратная доставка': 'return',
//   'закрыт': 'closed',
//   'отменен': 'cancelled',
// };

// const HOST = 'http://192.168.3.5:8089';

const RentalList = () => {
  const {user} = useAuth();
  const adminStatuses: string[] = ['создан', 'аренда', 'обратная доставка', 'закрыт', 'отменен'];
  const courierStatuses: string[] = ['создан', 'аренда', 'обратная доставка'];

  // const navigate = useNavigate();
  const [rentals, setRentals] = useState<IRental[]>([]);
  const [inRental, setInRental] = useState<IProductsInRental[]>([]);
  const [productOnUsers, setProductOnUsers] = useState<ProductUserMatrixProps>([]);
  const [bilitest, setBilitest] = useState<IBilitestRental>({inRent: false, rentalId: 0, startFrom: ""});
  const [filter, setFilter] = useState<string[]>(courierStatuses);
  const [loading, setLoading] = useState(false);

  const [dialog, setDialog] = useState<DialogData | null>(null);

  const handleConfirm = (id?: number | string) => {
    console.log('Confirmed with ID:', id);
  };

  axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  const fetchData = async () => {
    try {
      const [productsRes, rentalsRes, productsURes] = await Promise.all([
        // axios.get(`${HOST}/api/v1/rentals/getinrent`),
        axios.get(`${HOST}/api/v1/rentals/products`),
        axios.get(`${HOST}/api/v1/rentals`),
        axios.get(`${HOST}/api/v1/products/all`),
      ]);

      setRentals(rentalsRes.data);
      // console.log('products: ', productsRes.data)
      setInRental(productsRes.data);
      setProductOnUsers(productsURes.data);
    } catch (error) {
      console.log(error);
      console.error('Error in getting data');
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
    setLoading(false);
  }, []);

  useEffect(() => {
    getBillitestRentalStatus(rentals);
  }, [rentals]);

  const getBillitestRentalStatus = (rentals: IRental[]) => {
    if (!rentals) return;
    rentals.forEach(rental => {
      if (rental.status !== 'закрыт') {
        if (rental.extras) {
          rental.extras.forEach((extra) => {
            if (Number(extra.id) === 3) {
              setBilitest({
                inRent: true,
                rentalId: rental.id,
                startFrom: new Date(rental.start_date).toLocaleDateString('ru-RU')
              })
            }

          })
        }
      }
    })
  };

  const filteredRentals: IRental[] = filter.length === 0
    ? rentals
    : rentals.filter((r: any) => filter.includes(r.status));

  const todayStr = new Date().toLocaleDateString('ru-RU');
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  const tomorrowStr = tomorrow.toLocaleDateString('ru-RU');

  const filteredRentalsToday: IRental[] = rentals.filter((r: any) =>
    (new Date(r.start_date).toLocaleDateString('ru-RU') === todayStr && r.status === 'создан')
    || (new Date(r.end_date).toLocaleDateString('ru-RU') === todayStr && r.status === 'обратная доставка')
  );

  const filteredRentalsTomorrow: IRental[] = rentals.filter((r: any) =>
    (new Date(r.start_date).toLocaleDateString('ru-RU') === tomorrowStr && r.status === 'создан')
    || (new Date(r.end_date).toLocaleDateString('ru-RU') === tomorrowStr && r.status === 'обратная доставка')
  );

  const toggleFilter = (status: string) => {
    setFilter(prev => prev.includes(status)
      ? prev.filter(s => s !== status)
      : [...prev, status]);
  };

  return (
    <div>
      {loading && (
        <Loading/>
      )}
      <div>
        <Header/>
        <div className="mb-3 ">
          <div className="mb-3 rental-section">
            {(user.role === 'admin' ? adminStatuses : courierStatuses)
              .map(status => (
                <button
                  key={status}
                  className={`btn btn-sm me-2 ${filter.includes(status) ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => toggleFilter(status)}
                >
                  {status !== 'обратная доставка' ? status : 'повернення'}
                </button>
              ))}
          </div>
        </div>

        {user.role === 'admin' && (
          <div className="mb-3 rental-section">
            <h3>Лампи у оренді:</h3>
            {bilitest.inRent && (
              <div>
                <strong>Бiлiтест оренда:</strong> <a
                href={`/rental/${bilitest.rentalId}`}>#{bilitest.rentalId}</a> з {bilitest.startFrom}
              </div>
            )}
            <ProductUserMatrix data={productOnUsers}/>
          </div>
        )}

        {filteredRentalsToday.length > 0 && (
          <div>
            <b>Замовлення на сьогодні</b>
            <RentalListByDay
              filteredRentals={filteredRentalsToday}
              user={user}
              removeHandler={(id: number | string) => {
                axios.delete(`${HOST}/api/v1/rentals/${id}`).then(r => console.log(r));
                setRentals((prev) => prev.filter((rental) => rental.id !== id));
              }}
            />
          </div>
        )}

        {filteredRentalsTomorrow.length > 0 && (
          <div>
            <br/>
            <b>Замовлення на завтра</b>
            <RentalListByDay
              filteredRentals={filteredRentalsTomorrow}
              user={user}
              removeHandler={(id: number | string) => {
                axios.delete(`${HOST}/api/v1/rentals/${id}`).then(r => console.log(r));
                setRentals((prev) => prev.filter((rental) => rental.id !== id));
              }}
            />
          </div>
        )}

        <div>
          <br/>
          <b>Всі замовлення</b>
          <RentalListByDay
            filteredRentals={filteredRentals}
            user={user}
            removeHandler={(id: number | string) => {
              axios.delete(`${HOST}/api/v1/rentals/${id}`).then(r => console.log(r));
              setRentals((prev) => prev.filter((rental) => rental.id !== id));
            }}
          />
        </div>

      </div>

      <DialogModal
        isOpen={!!dialog}
        type={dialog?.type || 'error'}
        title={dialog?.title || ''}
        message={dialog?.message || ''}
        onClose={() => setDialog(null)}
        onConfirm={handleConfirm}
      />


    </div>
  );
};

export default RentalList;